/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Campos que puedes modificarse por PATCH por empresas.
 */
export type PatchEmpresaFields = 'titulo' | 'logotipo' | 'descripcion' | 'informacion' | 'informacionContentType' | 'infoReservas' | 'infoReservasContentType' | 'categorias' | 'direccion' | 'telefono' | 'celular' | 'pais' | 'departamento' | 'municipio' | 'facebook' | 'instagram' | 'twitter' | 'bancos' | 'correos';

export const PatchEmpresaFields = {
    Titulo: 'titulo' as PatchEmpresaFields,
    Logotipo: 'logotipo' as PatchEmpresaFields,
    Descripcion: 'descripcion' as PatchEmpresaFields,
    Informacion: 'informacion' as PatchEmpresaFields,
    InformacionContentType: 'informacionContentType' as PatchEmpresaFields,
    InfoReservas: 'infoReservas' as PatchEmpresaFields,
    InfoReservasContentType: 'infoReservasContentType' as PatchEmpresaFields,
    Categorias: 'categorias' as PatchEmpresaFields,
    Direccion: 'direccion' as PatchEmpresaFields,
    Telefono: 'telefono' as PatchEmpresaFields,
    Celular: 'celular' as PatchEmpresaFields,
    Pais: 'pais' as PatchEmpresaFields,
    Departamento: 'departamento' as PatchEmpresaFields,
    Municipio: 'municipio' as PatchEmpresaFields,
    Facebook: 'facebook' as PatchEmpresaFields,
    Instagram: 'instagram' as PatchEmpresaFields,
    Twitter: 'twitter' as PatchEmpresaFields,
    Bancos: 'bancos' as PatchEmpresaFields,
    Correos: 'correos' as PatchEmpresaFields
};

